import { render, staticRenderFns } from "./Key-position-personnel.vue?vue&type=template&id=37be87ba"
import script from "./Key-position-personnel.vue?vue&type=script&lang=js"
export * from "./Key-position-personnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports